import { REHYDRATE } from "redux-persist";
import { NOTIFICATION_FETCH_BEGIN, NOTIFICATION_FETCH_SUCCESS, NOTIFICATION_FETCH_FAIL} from '../actions/notificationActions';
import { LOGOUT } from "../actions/loginStateActions";

const INITAL_STATE = {
    data: {}
};
    
export default function notificationReducer(state = INITAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;
        case NOTIFICATION_FETCH_BEGIN: 
            return { data: {}, status: "fetching" };
        case NOTIFICATION_FETCH_SUCCESS:
        return {
            data: {
                ...action.data,
            },
            status: "viewing",
        };
        case NOTIFICATION_FETCH_FAIL:
            return { data: {}, status: "failed", failReason: action.reason };
        case LOGOUT:
            return { data: {}, status: "uninitialized" };
        default:
            return state;
    }
}
